export enum GeoPackageType {
  PLAN = 'plan',
  ASSET = 'asset'
}